import React, { Suspense } from 'react';
import TimeAgo from 'javascript-time-ago';
import ja from 'javascript-time-ago/locale/ja.json';
import queryClient from './lib/queryClient';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { AppRouter } from './routes';
import { ToastContainer } from 'react-toastify';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { LoadingProvider } from '@/providers/LoadingProvider';
import { HelmetProvider } from 'react-helmet-async';

function App() {
  TimeAgo.addLocale(ja);

  return (
    <QueryClientProvider client={queryClient}>
      {process.env.NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} />}
      <ToastContainer />
      <HelmetProvider>
        <LoadingProvider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </LoadingProvider>
      </HelmetProvider>
    </QueryClientProvider>
  );
}

export default App;
